export const APIS_COMPONENT_DESIGN = {
    // Chips compactos — mesmo padrão usado no filtro de respostas rápidas:
    // largura de conteúdo, sem trilho cinza por trás, seleção em violeta.
    tabs: {
        list: 'inline-flex h-auto items-center gap-2 rounded-none bg-transparent p-0 mb-6',
        trigger:
            'rounded-lg px-3 py-[7px] text-[13px] font-semibold border border-[#e7e7ec] bg-white text-[#52525b] whitespace-nowrap transition-colors hover:border-[#d4d4d8] hover:text-[#18181b] data-[state=active]:bg-[#ede9fe] data-[state=active]:border-[#a78bfa] data-[state=active]:text-[#5b21b6] data-[state=active]:shadow-none',
    },
    page: {
        // Header sticky full-bleed — padrão em configuracoes/CONFIG_PAGE_HEADER.md
        // (mesma estrutura de respostas-rapidas): root cuida do fundo/animação,
        // stickyHeader fica fixo no topo do scroll, container centraliza o padding
        // tanto no header quanto no corpo.
        root: "flex flex-col min-h-full w-full bg-[#f4f4f7] text-[#18181b] animate-in fade-in slide-in-from-bottom-4 duration-500",
        container: "w-full px-4 md:px-6 lg:px-8",
        stickyHeader: "sticky top-0 z-30 bg-white border-b border-[#e7e7ec]",
        pageBody: "pt-6 pb-[60px]",
        header: {
            container: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4 pt-[18px] pb-[18px]",
            wrapper: "flex items-start gap-3.5 min-w-0",
            title: "text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]",
            subtitle: "mt-[5px] text-[13px] text-[#71717a] leading-[1.5]"
        },
        actionButton: "flex items-center gap-2 px-4 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95"
    },
    emptyState: {
        container: "flex flex-col items-center justify-center p-12 bg-white rounded-xl border border-gray-100 border-dashed text-center",
        iconBox: "w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-4 text-gray-400",
        title: "text-lg font-semibold text-gray-900 mb-1",
        description: "text-gray-500 max-w-sm mb-6",
        button: "text-[#7C3AED] font-medium hover:underline text-sm"
    },
    dialog: {
        paper: {
            borderRadius: '16px',
            padding: '16px',
            boxShadow: '0px 20px 40px -4px rgba(0, 0, 0, 0.1), 0px 8px 16px -4px rgba(0, 0, 0, 0.05)'
        },
        container: "px-2 pb-2",
        header: {
            sx: { p: 2, pb: 1, fontSize: '1.25rem', fontWeight: 700, color: '#111827' }
        },
        content: {
            sx: { p: 2, pt: '16px !important' },
            wrapper: "flex flex-col gap-5",
            section: {
                label: "block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2",
                input: {
                    startAdornment: "text-gray-400",
                    sx: {
                        borderRadius: '12px',
                        backgroundColor: '#F9FAFB',
                        '& fieldset': { borderColor: '#E5E7EB' },
                        '&:hover fieldset': { borderColor: '#D1D5DB' },
                        '&.Mui-focused fieldset': { borderColor: '#7C3AED' },
                    }
                }
            },
        },
        actions: {
            sx: { p: 2, pt: 0 },
            cancelButton: "px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 rounded-lg transition-colors",
            confirmButton: {
                base: "px-6 py-2 text-sm font-medium text-white rounded-lg transition-all shadow-sm",
                disabled: "bg-gray-300 cursor-not-allowed",
                active: "bg-[#7C3AED] hover:bg-[#6d28d9] shadow-[#7C3AED]/20"
            }
        }
    }
};
